import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={10} cy={10} r={10} fill="#E40046" />
      <Path
        d="M7 14.132V5.869a1 1 0 011.555-.833l6.197 4.132a1 1 0 010 1.664l-6.197 4.131A1 1 0 017 14.133z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
